import { ScheduledChannelSnapshotFrequency } from 'dashboard/enums/scheduled-channel-snapshot-frequency.enum';

export const scheduledChannelSnapshotFrequencyTranslationMap = {
    [ScheduledChannelSnapshotFrequency.DAILY]: 'dashboard.scheduledChannelSnapshots.frequency.daily',
    [ScheduledChannelSnapshotFrequency.WEEKLY]: 'dashboard.scheduledChannelSnapshots.frequency.weekly',
    [ScheduledChannelSnapshotFrequency.MONTHLY]: 'dashboard.scheduledChannelSnapshots.frequency.monthly',
    [ScheduledChannelSnapshotFrequency.MANUAL]: 'dashboard.scheduledChannelSnapshots.frequency.manual',
};
